import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the currencyManagementView.
 * Extends the JetView class to create a specific view for currency management.
 */
export default class currencyManagementTable extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */

    config() {
        var _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        var canEdit = devConfig.getPermAction('updateCurrencyStatus', 'Edit');
        var header = [
            {
                id: 'edit',
                header: '',
                width: 50,
                height: 25,
                template: function (obj) {
                    // Template function to display edit icon based on permissions
                     return "<span class='webix_icon wxi-close edit'></span>"; // Icon for editing
                },
            },
            {
                id: 'Currency',
                header: _('Moneda'), // Localized header
                width: 100,
                sort: 'string', // Sorting type
                fillspace: 1,
            },
            {
                id: 'NumberCode',
                header: _('Código'), // Localized header
                width: 100,
                sort: 'string',
                fillspace: 1,
            },
            {
                id: 'Description',
                header: _('Descripción'), // Localized header
                width: 150,
                sort: 'string',
                fillspace: 2,
            },
            {
                id: 'Status',
                header: _('Estatus'), // Localized header
                width: 150,
                sort: 'string',
                template: function (obj) {
                    if (obj.Status === 'A') return _('Activo');
                    if (obj.Status === 'I') return _('Inactivo');
                    return obj.Status || '';
                },
            },
            {
                id: 'Symbol',
                header: _('Símbolo'), // Localized header
                width: 100,
                sort: 'string',
                fillspace: 1,
            },
        ];
        if (!canEdit) {
            header= header.filter((item) =>item.id !== "edit")
        }
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'datatable',
                            view: 'datatable',
                            gravity: 1,
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: header,
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 * Displays a loading overlay.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Event triggered after loading data.
                                 * Hides the loading overlay.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                    if (!this.count()) {
                                        this.showOverlay(
                                            "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                                _('No hay datos') +
                                                '</div>',
                                        );
                                    }
                                },
                            },
                            onClick: {
                                /**
                                 * Event triggered when the edit icon is clicked.
                                 * Opens the edit form for the selected item.
                                 * @param {Event} euv - The event object.
                                 * @param {String} id - The ID of the clicked item.
                                 */
                               
                                edit: function (e, id) {
                                    // In datatable clicks, `id` is usually an object: { row, column }
                                    var rowId = id && id.row ? id.row : id;
                                    var item = this.getItem(rowId); // Get the clicked item (row data)
                                    vthis.app.callEvent('openEdit', [item]); // Trigger the openEdit event
                                    return false;
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable instance
        var url = devConfig.geturlApi() + 'Setting/Currency/GetCurrencies'; // API URL for fetching
        // loadData('');
        var _filterData = {};
        
        function buildFilter(filterData) {
            let payload = '';
            var obj = filterData || {};
            Object.keys(obj).forEach(function (key) {
                var val = obj[key];
                if (val !== null && val !== undefined && val !== '') {
                    payload += '&' + key + '=' + val;
                }
            });
            return payload;
        }
        /**
         * Event to make the request and bring the coins
         */
        function loadData() {
            var pager = grid.getPager();
            var page = pager ? pager.config.page : 0;
            var size = pager ? pager.config.size : devConfig.getDefaultDataFetch();
            var start = page * size;
            var count = size;
            var fullUrl = url + '?start=' + start + '&count=' + count + buildFilter(_filterData);

            return webix.ajax().get(fullUrl).then(function (res) {
                var json = res.json();
                return {
                    pos: Number(json.pos) || 0,
                    total_count: Number(json.total_count) || 0,
                    data: json.Data || [],
                };
            });
        }
        grid.load(loadData);
        /**
         * Event listener for the 'report:filter' event.
         * Updates the grid data based on the provided filter data.
         * @param {Object} filterData - The filter data object.
         */
        this.on(this.app, 'report:filter', (filterData) => {
            _filterData = filterData || {};
            var pager = grid.getPager();
            if (pager) pager.select(0);
            grid.clearAll();
            grid.load(loadData);
        });

        /**
         * Event listener for the 'openEdit' event.
         * Opens the edit form for the selected item.
         * @param {Object} item - The item to edit.
         */
        this.on(this.app, 'openEdit', (item) => {
            // Avoid duplicated IDs if the user opens the editor multiple times
            var prev = $$('editMenu');
            if (prev) prev.destructor();

            var win = webix.ui({
                view: 'window',
                id: 'editMenu',
                fullscreen: screen.width < 500 ? true : false,
                width: 500,
                head: {
                    view: 'toolbar',
                    cols: [
                        { view: 'label', label: _('Editar'), align: 'center' },
                        {
                            view: 'icon',
                            icon: 'wxi-close',
                            click: function () {
                                this.getTopParentView().hide();
                            },
                        },
                    ],
                },
                position: 'center',
                modal: true,
                body: {
                    view: 'form',
                    id: 'editform',
                    elements: [
                        {
                            cols: [
                                {
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Moneda'),
                                            name: 'Currency',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Simbolo'),
                                            name: 'Symbol',
                                            disabled: true,
                                        },
                                        {
                                            view: 'combo',
                                            labelPosition: 'top',
                                            label: _('Estado'),
                                            name: 'State',
                                            options: [
                                                { id: 'A', value: _('Activo') },
                                                { id: 'I', value: _('Inactivo') },
                                            ],
                                            required: true,
                                        },
                                    ],
                                },
                                {
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Descripción'),
                                            name: 'Description',
                                            disabled: true,
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Código'),
                                            name: 'NumberCode',
                                            disabled: true,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            cols: [
                                {
                                    view: 'button',
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide();
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function () {
                                        var form = $$('editform');
                                        if (!form.validate()) return;

                                        var values = form.getValues();
                                        var payload = {
                                            NumberCode: values.NumberCode,
                                            Symbol: values.Symbol,
                                            Description: values.Description,
                                            Currency: values.Currency,
                                            State: values.State, // "A" or "I"
                                        };
                                        webix
                                            .ajax()
                                            .headers({ 'Content-type': 'application/json' })
                                            .post(devConfig.geturlApi() + 'Currency/SaveCurrency', payload, {
                                                error: function () {
                                                    webix.message('Error! ');
                                                },
                                                success: function (text) {
                                                    let resp;
                                                    try {
                                                        resp = JSON.parse(text);
                                                    } catch (e) {
                                                        webix.message('Respuesta inválida del servidor');
                                                        return;
                                                    }

                                                    if (resp.HasError) {
                                                        webix.message('Error: ' + resp.AlertMessage);
                                                    } else {
                                                        webix.message('Moneda editada satisfactoriamente');
                                                        loadData('');
                                                    }
                                                },
                                            });
                                        this.getTopParentView().hide();
                                    },
                                },
                            ],
                        },
                    ],
                },
            });

            win.show();
            //Map datatable field "State" -> API/form field "state"
            $$('editform').setValues(
                {
                    ...item,
                    State: item.Status,
                },
                true,
            );
            $$('editform').clearValidation();
        });
    }
}